<template>
  <div>
    <b-overlay :show="loading" rounded="sm" :style="loading ? 'height:800px;overflow:hidden;' : ''">
      <PageValidate ref="logs" :MediaListRef="MediaListRef">
        <template v-slot:PageBody>
          <div class="CenterCard" v-if="APlusABCBooth || haveEMPButtonAd">
            <BasicPageTop :Name="$t('lbl_EMPBE_CompanyInfo_eBooth_HeaderOfEBooth')">
            </BasicPageTop>
            <div>
              <div class="row">
                <div class="col-5 CompanyIntroductionImg">
                  <ImgPrivewDilog v-if="(!haveEMPButtonAd || APlusABCBooth)" :title="$t('lbl_EMPBE_Preview')"
                    :id="'ComapnyInfo_eBooth_Header_Img'" :url="GetEBoothPhotoPrivew"></ImgPrivewDilog>
                </div>
                <div class="col-7">
                  <div class="row">
                    <div class="col-12 mb-2 Input_Label">
                      <div class="Input_Label_Left">
                        1. {{ $t("lbl_EMPBE_CompanyInfo_eBooth_CompanyLogo") }}<span class="text-danger"> *</span>
                      </div>
                    </div>
                    <div class="col-12 PictureSize" v-html="$t('lbl_EMPBE_CompanyInfo_eBooth_CompanyLogo_P')">
                    </div>
                    <div class="col-12 company-logo-uploader">
                      <MediaApprovalGallery
                        v-if="shouldShowMediaApprovalGallery(companyLogo)"
                        :MediaArray="companyLogo"
                        mode="admin"
                        media-type="image"
                        gallery-item-style="height: 120px; width: 120px;"
                        :title="$t('lbl_EMPBE_CompanyInfo_eBooth_CompanyLogo')"
                        :approval-content-results="getMediaApprovalResults('CompanyLogo')"
                        :approval-content-result-drafts="getMediaApprovalDraftMap('CompanyLogo', companyLogo)"
                        :rejection-templates="mediaApprovalRejectionTemplates"
                        :rejection-actor="mediaApprovalRejectionActor"
                        @approval-draft-change="onMediaApprovalDraftChange('CompanyLogo', $event)"
                      />
                      <template v-else>
                        <mediaUploader
                          :MediaArray="companyLogo"
                          ref="companyLogo"
                          :isRequired="true"
                          :isDisabled="isApprovalMediaReadOnly"
                          aspectRatioStr="1:1"
                          galleryItemStyle="height: 120px; width: 120px;"
                          :limit="1"
                          :coverPlaceholder="$t('lbl_EMPBE_CompanyInfo_Add_Cover_Image')"
                          :roundBorder="true"
                          fileUsageType="companyLogo"
                          filePathEndpoint="Image"
                          :reject-records="getMediaRejectRecords('CompanyLogo', companyLogo, 'image')"
                          @update="(cmd, files) => handlerUploaderUpdateData(cmd, files, 'companyLogo')"
                        />
                        <MediaRejectBanner :records="getMediaRejectRecords('CompanyLogo', companyLogo, 'image')" />
                      </template>
                    </div>
                  </div>
                  <div v-if="(!haveEMPButtonAd || APlusABCBooth)"
                    style="border: 1px solid #F0F1F2;;height: 1px;margin-top: 25px;margin-bottom: 25px;"></div>

                  <div class="row" v-if="(!haveEMPButtonAd || APlusABCBooth)">
                    <div class="col-12 mb-2 Input_Label">
                      <div class="Input_Label_Left">
                        <TipsAndPrivewDilog :id="'EMPBE_Comp_Banner_theme_Info'" :Type="1" :Url="GetTheme_InfoPrivew"
                          :DilogTitle="$t('lbl_EMPBE_Preview')">
                          <template v-slot:Text>
                            2. {{ $t("lbl_EMPBE_CompanyInfo_eBooth_ThemeOfEBooth") }}<span class="text-danger">
                              *</span>
                          </template>
                        </TipsAndPrivewDilog>
                      </div>
                    </div>
                    <div class="col-12">
                      <LogoImgTheme v-model="form.eBoothTemplate"></LogoImgTheme>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="CenterCard" v-if="APlusABBooth">
            <BasicPageTop :Name="$t('lbl_EMPBE_CompanyInfo_eBooth_Homepage')">
            </BasicPageTop>
            <div>
              <div class="row">
                <div class="col-5 CompanyIntroductionImg">
                  <ImgPrivewDilog :title="$t('lbl_EMPBE_Preview')" :id="'ComapnyInfo_Homepage_Img'"
                    :url="GetHomepagePrivew">
                  </ImgPrivewDilog>
                </div>
                <div class="col-7">
                  <div class="row">
                    <div class="col-12 mb-2 Input_Label">
                      <div class="Input_Label_Left">
                        1. {{ $t("lbl_EMPBE_CompanyInfo_eBooth_SpotlightSlidingBanners") }}
                      </div>
                    </div>
                    <div class="SpotlightSlidingBanners col-12">
                      <div class="SpotlightSlidingBanners_PC">
                        <div class="col-12 HomePagePictureType">
                          {{$t("Desktop")}} <span class="text-danger">*</span>
                        </div>
                        <div class="col-12 PictureSize">
                          {{ $t("lbl_EMPBE_CompanyInfo_eBooth_SpotlightSlidingBanners_p") }}
                        </div>
                        <div class="col-12">
                          <MediaApprovalGallery
                            v-if="shouldShowMediaApprovalGallery(homepagePicture)"
                            :MediaArray="homepagePicture"
                            mode="admin"
                            media-type="image"
                            :is-show-cover="true"
                            gallery-item-style="height: 80px; width: 180px;"
                            :grid-template-columns="'repeat(2, 1fr)'"
                            :title="$t('lbl_EMPBE_CompanyInfo_eBooth_SpotlightSlidingBanners') + ' (' + $t('Desktop') + ')'"
                            :approval-content-results="getMediaApprovalResults('BannerSlider')"
                            :approval-content-result-drafts="getMediaApprovalDraftMap('BannerSlider', homepagePicture)"
                            :rejection-templates="mediaApprovalRejectionTemplates"
                            :rejection-actor="mediaApprovalRejectionActor"
                            @approval-draft-change="onMediaApprovalDraftChange('BannerSlider', $event)"
                          />
                          <template v-else>
                            <mediaUploader
                              :isShowCover="true"
                              :isRequired="true"
                              :isDisabled="isApprovalMediaReadOnly"
                              componentId="homepagePicture"
                              :MediaArray="homepagePicture"
                              ref="homepagePicture"
                              aspectRatioStr="9:4"
                              :limit="8"
                              galleryItemStyle="height: 80px; width: 180px;"
                              :coverPlaceholder="$t('lbl_EMPBE_CompanyInfo_Add_Cover_Image')"
                              :gridTemplateColumns="'repeat(2, 1fr)'"
                              :singleAddButton="true"
                              fileUsageType="homepagePicture"
                              filePathEndpoint="Image"
                              :reject-records="getMediaRejectRecords('BannerSlider', homepagePicture, 'image')"
                              @update="(cmd, files) => handlerUploaderUpdateData(cmd, files, 'homepagePicture')"
                            />
                            <MediaRejectBanner :records="getMediaRejectRecords('BannerSlider', homepagePicture, 'image')" />
                          </template>
                        </div>
                      </div>
                      <div class="SpotlightSlidingBanners_MB">
                        <div class="col-12 HomePagePictureType">
                          {{$t("Mobile")}} <span class="text-danger">*</span>
                        </div>
                        <div class="col-12 PictureSize">
                          {{ $t("lbl_EMPBE_CompanyInfo_eBooth_SpotlightSlidingBanners_Mb_p") }}
                        </div>
                        <div class="col-12">
                          <MediaApprovalGallery
                            v-if="shouldShowMediaApprovalGallery(homepagePicture_MB)"
                            :MediaArray="homepagePicture_MB"
                            mode="admin"
                            media-type="image"
                            :is-show-cover="true"
                            gallery-item-style="height: 102px; width: 80px;"
                            :grid-template-columns="'repeat(4, 1fr)'"
                            :title="$t('lbl_EMPBE_CompanyInfo_eBooth_SpotlightSlidingBanners') + ' (' + $t('Mobile') + ')'"
                            :approval-content-results="getMediaApprovalResults('BannerSlider')"
                            :approval-content-result-drafts="getMediaApprovalDraftMap('BannerSlider', homepagePicture_MB)"
                            :rejection-templates="mediaApprovalRejectionTemplates"
                            :rejection-actor="mediaApprovalRejectionActor"
                            @approval-draft-change="onMediaApprovalDraftChange('BannerSlider', $event)"
                          />
                          <template v-else>
                            <mediaUploader
                              :isShowCover="true"
                              :isRequired="true"
                              :isDisabled="isApprovalMediaReadOnly"
                              componentId="homepagePicture_MB"
                              :MediaArray="homepagePicture_MB"
                              ref="homepagePicture_MB"
                              aspectRatioStr="390:500"
                              :limit="8"
                              galleryItemStyle="height: 102px; width: 80px;"
                              :coverPlaceholder="$t('lbl_EMPBE_CompanyInfo_Add_Cover_Image')"
                              :gridTemplateColumns="'repeat(4, 1fr)'"
                              :singleAddButton="true"
                              fileUsageType="homepagePicture_MB"
                              filePathEndpoint="Image"
                              :reject-records="getMediaRejectRecords('BannerSlider', homepagePicture_MB, 'image')"
                              @update="(cmd, files) => handlerUploaderUpdateData(cmd, files, 'homepagePicture_MB')"
                            />
                            <MediaRejectBanner :records="getMediaRejectRecords('BannerSlider', homepagePicture_MB, 'image')" />
                          </template>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div style="border: 1px solid #F0F1F2;;height: 1px;margin-top: 25px;margin-bottom: 25px;"></div>

                  <div class="row">
                    <div class="col-12 mb-2 Input_Label">
                      <div class="Input_Label_Left">
                        2. {{ $t("lbl_EMPBE_CompanyInfo_eBooth_BusinessSpotlights") }} <span class="text-danger">
                          *</span>
                      </div>
                    </div>
                    <div class="col-12  PictureSize">
                      {{ $t("lbl_EMPBE_CompanyInfo_eBooth_BusinessSpotlights_p") }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 mb-2 Input_Label">
                      <div class="Input_Label_Left">
                        {{ $t("lbl_EMPBE_CompanyInfo_eBooth_Headline_En") }}<span class="text-danger"> *</span>
                      </div>
                    </div>
                    <div class="col-12">
                      <customtextarea rules="min:5|max:50|required" ControlId="headlineEng" max="50" rows="2"
                        v-model="form.headlineEng" :title="$t('lbl_EMPBE_CompanyInfo_eBooth_Headline_PlaceOther_En')"
                        CharLimit="CheckEnglishChar"
                        :mandatory="$t('lbl_EMPBE_CompanyInfo_eBooth_Headline_En') + $t('lbl_IsRequire')"  >
                      </customtextarea>
                      <CompanyFieldApprovalResults usage-type="headlineE" />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <customtextarea :title="$t('lbl_EMPBE_CompanyInfo_eBooth_Description_En')" rows="5"
                        ControlId="bodyEng" :placeholder="$t('lbl_EMPBE_CompanyInfo_eBooth_Description_PlaceOther_En')"
                        v-model="form.bodyEng" max="1000"
                        :customErrorMessage="{ max: $t('lbl_EMPBE_PIG_InputExceedLimit') }"
                        :mandatory="$t('lbl_EMPBE_CompanyInfo_eBooth_Description_En') + $t('lbl_IsRequire')"
                        CharLimit="CheckEnglishChar">
                      </customtextarea>
                      <CompanyFieldApprovalResults usage-type="bodyTextE" />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 mb-2 Input_Label">
                      <div class="Input_Label_Left">
                        {{ $t("lbl_EMPBE_CompanyInfo_eBooth_Headline_Cn") }}<span class="text-danger"> *</span>
                      </div>
                    </div>
                    <div class="col-12">
                      <customtextarea ControlId="headlineCn" rules="min:1|max:50|required" max="50"  rows="3"
                        v-model="form.headlineCn" :title="$t('lbl_EMPBE_CompanyInfo_eBooth_Headline_PlaceOther_Cn')"
                        :mandatory="$t('lbl_EMPBE_CompanyInfo_eBooth_Headline_Cn') + $t('lbl_IsRequire')" >
                      </customtextarea>
                      <CompanyFieldApprovalResults usage-type="headlineS" />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <customtextarea :title="$t('lbl_EMPBE_CompanyInfo_eBooth_Description_Cn')" ControlId="bodyCn"
                        rows="5" v-model="form.bodyCn" max="500"
                        :placeholder="$t('lbl_EMPBE_CompanyInfo_eBooth_Description_PlaceOther_Cn')"
                        :customErrorMessage="{ max: $t('lbl_EMPBE_PIG_InputExceedLimit') }"
                        :mandatory="$t('lbl_EMPBE_CompanyInfo_eBooth_Description_Cn') + $t('lbl_IsRequire')">
                      </customtextarea>
                      <CompanyFieldApprovalResults usage-type="bodyTextS" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="CenterCard" v-if="APlusABCBooth" v-show="false">
            <BasicPageTop :Name="$t('lbl_EMPBE_CompanyInfo_eBooth_Profile')">
            </BasicPageTop>
            <div>
              <div class="row">
                <div class="col-5 CompanyIntroductionImg">
                  <ImgPrivewDilog :title="$t('lbl_EMPBE_Preview')" :id="'ComapnyInfo_Company_Profile_Page_Img'"
                    :url="GetBussinessProfilePrivew"></ImgPrivewDilog>
                </div>
                <div class="col-7">
                  <div class="row">
                    <div class="col-12 mb-2 Input_Label">
                      <div class="Input_Label_Left">
                        1. {{ $t("lbl_EMPBE_CompanyInfo_eBooth_TopBanner") }}<span class="text-danger"> *</span>
                      </div>
                    </div>
                    <div class="col-12 PictureSize" v-html="$t('lbl_EMPBE_CompanyInfo_eBooth_TopBanner_P')">
                    </div>
                    <div class="col-12">
                      <mediaUploader
                        :isRequired="true"
                        componentId="companyImagePictures1"
                        :MediaArray="companyImagePictures1"
                        ref="companyImagePictures1"
                        aspectRatioStr="1920:553"
                        :limit="1"
                        galleryItemStyle="height: 78px; width: 270px;"
                        :coverPlaceholder="$t('lbl_EMPBE_CompanyInfo_Add_Cover_Image')"
                        fileUsageType="companyImagePictures1"
                        filePathEndpoint="Image"
                        @update="(cmd, files) => handlerUploaderUpdateData(cmd, files, 'companyImagePictures1')"
                      />
                    </div>
                  </div>
                  <div style="border: 1px solid #F0F1F2;;height: 1px;margin-top: 25px;margin-bottom: 25px;"></div>

                  <div class="row">
                    <div class="col-12">
                      <!-- :customErrorMessage="{ max: $t('lbl_EMPBE_PIG_InputExceedLimit') }"
                        :mandatory="$t('lbl_EMPBE_CompanyInfo_eBooth_FirstIntro_En') + $t('lbl_IsRequire')" -->
                      <customtextarea rows="10" :title="'2A. ' + $t('lbl_EMPBE_CompanyInfo_eBooth_FirstIntro_En')"
                        ControlId="paraEng1"
                        :placeholder="$t('lbl_EMPBE_CompanyInfo_eBooth_Description_PlaceOther_En_1500')"
                        v-model="form.paraEng1" max="1500" 
                        CharLimit="CheckEnglishChar">
                      </customtextarea>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 ">
                       <!-- :customErrorMessage="{ max: $t('lbl_EMPBE_PIG_InputExceedLimit') }"
                        :mandatory="$t('lbl_EMPBE_CompanyInfo_eBooth_FirstIntro_Cn') + $t('lbl_IsRequire')" -->
                      <customtextarea rows="10" ControlId="paraCn1"
                        :title="'2A. ' + $t('lbl_EMPBE_CompanyInfo_eBooth_FirstIntro_Cn')"
                        :placeholder="$t('lbl_EMPBE_CompanyInfo_eBooth_Description_PlaceOther_Cn')"
                        v-model="form.paraCn1" max="750" 
                        >
                      </customtextarea>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 mb-2 Input_Label">
                      <div class="Input_Label_Left">
                        2A. {{ $t("lbl_EMPBE_CompanyInfo_eBooth_FirstImageOfCompany") }}<span class="text-danger">
                          *</span>
                      </div>
                    </div>
                    <div class="col-12 PictureSize">
                      {{ $t("lbl_EMPBE_CompanyInfo_eBooth_FirstImageOfCompany_p") }}
                    </div>
                    <div class="col-12">
                      <mediaUploader
                        :isRequired="true"
                        componentId="companyImagePictures2"
                        :MediaArray="companyImagePictures2"
                        ref="companyImagePictures2"
                        aspectRatioStr="5:3"
                        :limit="1"
                        galleryItemStyle="height: 78px; width: 133px;"
                        :coverPlaceholder="$t('lbl_EMPBE_CompanyInfo_Add_Cover_Image')"
                        fileUsageType="companyImagePictures2"
                        filePathEndpoint="Image"
                        @update="(cmd, files) => handlerUploaderUpdateData(cmd, files, 'companyImagePictures2')"
                      />
                    </div>
                  </div>

                  <div style="border: 1px solid #F0F1F2;;height: 1px;margin-top: 25px;margin-bottom: 25px;"></div>

                  <div class="row">
                    <div class="col-12">
                       <!-- :customErrorMessage="{ max: $t('lbl_EMPBE_PIG_InputExceedLimit') }"
                        :mandatory="'2B. ' + $t('lbl_EMPBE_CompanyInfo_eBooth_SeconedIntro_En') + $t('lbl_IsRequire')" -->
                      <customtextarea rows="10" :title="'2B. ' + $t('lbl_EMPBE_CompanyInfo_eBooth_SeconedIntro_En')"
                        ControlId="paraEng2" :placeholder="$t('lbl_EMPBE_CompanyInfo_eBooth_Description_PlaceOther_En')"
                        v-model="form.paraEng2" max="1500"
                       
                        CharLimit="CheckEnglishChar">
                      </customtextarea>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 ">

                      <!-- :customErrorMessage="{ max: $t('lbl_EMPBE_PIG_InputExceedLimit') }"
                        :mandatory="'2B. ' + $t('lbl_EMPBE_CompanyInfo_eBooth_SeconedIntro_Cn') + $t('lbl_IsRequire')" -->

                      <customtextarea rows="10" ControlId="paraCn2"
                        :title="'2B. ' + $t('lbl_EMPBE_CompanyInfo_eBooth_SeconedIntro_Cn')"
                        :placeholder="$t('lbl_EMPBE_CompanyInfo_eBooth_Description_PlaceOther_Cn')"
                        v-model="form.paraCn2" max="750"                        
                        
                        >
                      </customtextarea>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 mb-2 Input_Label">
                      <div class="Input_Label_Left">
                        2B. {{ $t("lbl_EMPBE_CompanyInfo_eBooth_SeconedImageOfCompany") }}<span class="text-danger">
                          *</span>
                      </div>
                    </div>
                    <div class="col-12 PictureSize">
                      {{ $t("lbl_EMPBE_CompanyInfo_eBooth_SeconedImageOfCompany_PP") }}
                    </div>
                    <div class="col-12">
                      <mediaUploader
                        :isRequired="true"
                        componentId="companyImagePictures3"
                        :MediaArray="companyImagePictures3"
                        ref="companyImagePictures3"
                        aspectRatioStr="5:3"
                        :limit="1"
                        galleryItemStyle="height: 78px; width: 133px;"
                        :coverPlaceholder="$t('lbl_EMPBE_CompanyInfo_Add_Cover_Image')"
                        fileUsageType="companyImagePictures3"
                        filePathEndpoint="Image"
                        @update="(cmd, files) => handlerUploaderUpdateData(cmd, files, 'companyImagePictures3')"
                      />
                    </div>
                  </div>
                <!--图片集锦 移到推广广告-->
                 <!--   <div style="border: 1px solid #F0F1F2;;height: 1px;margin-top: 25px;margin-bottom: 25px;"></div>
   
                 <div class="row">
                    <div class="col-12 mb-2 Input_Label">
                      <div class="Input_Label_Left">
                        3. {{ $t("lbl_EMPBE_CompanyInfo_eBooth_PhotoGallery") }}
                      </div>
                    </div>
                    <div class="col-12 PictureSize"
                      v-html="$t('lbl_EMPBE_CompanyInfo_eBooth_PhotoGallery_P', { nums: GetPhotoGalleryNums })">
                    </div>
                    <div class="col-12">
                      <mediaUploader
                        :isShowCover="true"
                        componentId="eBooth_Gallery"
                        :MediaArray="eBooth_Gallery"
                        ref="eBooth_Gallery"
                        aspectRatioStr="5:3"
                        :limit="GetPhotoGalleryNums"
                        galleryItemStyle="height: 77px; width: 138px;"
                        :coverPlaceholder="$t('lbl_EMPBE_CompanyInfo_Add_Cover_Image')"
                        :gridTemplateColumns="'repeat(2, 1fr)'"
                        :singleAddButton="true"
                        fileUsageType="eBooth_Gallery"
                        filePathEndpoint="Image"
                        @update="(cmd, files) => handlerUploaderUpdateData(cmd, files, 'eBooth_Gallery')">
                      />
                    </div>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
          <div class="CenterCard" v-if="MemberAndGuestBooth">
            <BasicPageTop :Name="$t('lbl_EMPBE_CompanyInfo_eBooth_Introduction')">
            </BasicPageTop>
            <div>
              <div class="row">
                <div class="col-5 CompanyIntroductionImg">
                  <ImgPrivewDilog :title="$t('lbl_EMPBE_Preview')" :id="'ComapnyInfo_BriefIntroduction_Img'"
                    :url="GetBriefIntroductionPrivew">
                  </ImgPrivewDilog>
                </div>
                <div class="col-7">
                  <div class="row">
                    <div class="col-12 mb-2 Input_Label">
                      <div class="Input_Label_Left">
                        1. {{ $t("lbl_EMPBE_CompanyInfo_eBooth_BriefIntroduction") }} <span class="text-danger">
                          *</span>
                      </div>
                    </div>
                    <div class="col-12 PictureSize">
                      {{ $t("lbl_EMPBE_CompanyInfo_eBooth_BriefIntroduction_P") }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <customtextarea :title="$t('lbl_EMPBE_CompanyInfo_eBooth_BriefIntro_En')" rows="5"
                        ControlId="bodyEng" :placeholder="$t('lbl_EMPBE_CompanyInfo_eBooth_BriefIntro_PlaceOther_En')"
                        v-model="form.bodyEng" max="1000"
                        :customErrorMessage="{ max: $t('lbl_EMPBE_PIG_InputExceedLimit') }"
                        :mandatory="$t('lbl_EMPBE_CompanyInfo_eBooth_BriefIntro_En') + $t('lbl_IsRequire')"
                        CharLimit="CheckEnglishChar">
                      </customtextarea>
                      <CompanyFieldApprovalResults usage-type="briefIntroE" />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <customtextarea :title="$t('lbl_EMPBE_CompanyInfo_eBooth_BriefIntro_Cn')" ControlId="bodyCn"
                        rows="5" v-model="form.bodyCn" max="500"
                        :placeholder="$t('lbl_EMPBE_CompanyInfo_eBooth_BriefIntro_PlaceOther_Cn')"
                        :customErrorMessage="{ max: $t('lbl_EMPBE_PIG_InputExceedLimit') }"
                        :mandatory="$t('lbl_EMPBE_CompanyInfo_eBooth_BriefIntro_Cn') + $t('lbl_IsRequire')">
                      </customtextarea>
                      <CompanyFieldApprovalResults usage-type="briefIntroS" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="CenterCard">
            <BasicPageTop :Name="$t('lbl_EMPBE_CompanyInfo_eBooth_VideoPromotion')">
            </BasicPageTop>
            <div>
              <div class="row">
                <div class="col-5">
                  <img src="" />
                </div>
                <div class="col-7">

                  <div class="row">
                    <div class="col-12 mb-2 Input_Label">
                      <div class="Input_Label_Left">
                        {{
                          $t("lbl_EMPBE_CompanyInfo_eBooth_CompanyVideo", {
                            UsedQuota:
                              UploadedList.companyVideo.length, MaxQuota: GetVideoNums
                          })
                        }}&nbsp;&nbsp;<span class="NewsTips">{{
                          $t("lbl_EMPBE_News") }}</span>
                      </div>
                    </div>
                    <div class="col-12 PictureSize" v-html="$t('lbl_EMPBE_CompanyInfo_eBooth_CompanyVideo_P')">
                    </div>
                    <div class="col-12">
                      <MediaApprovalGallery
                        v-if="shouldShowMediaApprovalGallery(companyVideo)"
                        :MediaArray="companyVideo"
                        mode="admin"
                        media-type="video"
                        :is-show-cover="true"
                        gallery-item-style="height: 77px; width: 138px;"
                        :grid-template-columns="'repeat(2, 1fr)'"
                        :title="$t('lbl_EMPBE_CompanyInfo_eBooth_CompanyVideo', { UsedQuota: UploadedList.companyVideo.length, MaxQuota: GetVideoNums })"
                        :approval-content-results="getMediaApprovalResults('CompanyVideo')"
                        :approval-content-result-drafts="getMediaApprovalDraftMap('CompanyVideo', companyVideo)"
                        :rejection-templates="mediaApprovalRejectionTemplates"
                        :rejection-actor="mediaApprovalRejectionActor"
                        @approval-draft-change="onMediaApprovalDraftChange('CompanyVideo', $event)"
                      />
                      <template v-else>
                        <mediaUploader
                          :isShowCover="true"
                          :isDisabled="isApprovalMediaReadOnly"
                          mediaType="video"
                          componentId="companyVideo"
                          ref="companyVideo"
                          aspectRatioStr="16:9"
                          :MediaArray="companyVideo"
                          :limit="GetVideoNums"
                          galleryItemStyle="height: 77px; width: 138px;"
                          :coverPlaceholder="$t('lbl_EMPBE_CompanyInfo_Add_Video')"
                          :gridTemplateColumns="'repeat(2, 1fr)'"
                          :singleAddButton="true"
                          :maxSize="100"
                          fileUsageType="companyVideo"
                          filePathEndpoint="Video"
                          fileThumbnailUsageType="companyVideo_Cover"
                          fileThumbnailPathEndpoint="VideoCapture"
                          :reject-records="getMediaRejectRecords('CompanyVideo', companyVideo, 'video')"
                          @update="(cmd, files) => handlerUploaderUpdateData(cmd, files, 'companyVideo')"
                        />
                        <MediaRejectBanner :records="getMediaRejectRecords('CompanyVideo', companyVideo, 'video')" />
                      </template>
                    </div>
                  </div>
                  <div style="border: 1px solid #F0F1F2;;height: 1px;margin-top: 25px;margin-bottom: 25px;"></div>

                  <div class="row ShortVideo">
                    <div class="col-12 mb-2 Input_Label">
                      <div class="Input_Label_Left">
                        {{
                          $t("lbl_EMPBE_CompanyInfo_eBooth_CompanyShortVideo", {
                            UsedQuota:
                              UploadedList.companyVideo_Short.length, MaxQuota: GetVideoNums
                          })
                        }}&nbsp;&nbsp;<span class="NewsTips">{{
                          $t("lbl_EMPBE_News") }}</span>
                      </div>
                    </div>
                    <div class="col-12 PictureSize" v-html="$t('lbl_EMPBE_CompanyInfo_eBooth_CompanyShortVideo_P')">
                    </div>
                    <div class="col-12">
                      <MediaApprovalGallery
                        v-if="shouldShowMediaApprovalGallery(companyVideo_Short)"
                        :MediaArray="companyVideo_Short"
                        mode="admin"
                        media-type="video"
                        :is-show-cover="true"
                        gallery-item-style="height: 190px; width: 112px;"
                        :grid-template-columns="'repeat(2, 1fr)'"
                        :title="$t('lbl_EMPBE_CompanyInfo_eBooth_CompanyShortVideo', { UsedQuota: UploadedList.companyVideo_Short.length, MaxQuota: GetVideoNums })"
                        :approval-content-results="getMediaApprovalResults('CompanyShortVideo')"
                        :approval-content-result-drafts="getMediaApprovalDraftMap('CompanyShortVideo', companyVideo_Short)"
                        :rejection-templates="mediaApprovalRejectionTemplates"
                        :rejection-actor="mediaApprovalRejectionActor"
                        @approval-draft-change="onMediaApprovalDraftChange('CompanyShortVideo', $event)"
                      />
                      <template v-else>
                        <mediaUploader
                          :isShowCover="true"
                          :isDisabled="isApprovalMediaReadOnly"
                          mediaType="video"
                          componentId="companyVideo_Short"
                          ref="companyVideo_Short"
                          aspectRatioStr="9:16"
                          :MediaArray="companyVideo_Short"
                          :limit="GetVideoNums"
                          galleryItemStyle="height: 190px; width: 112px;"
                          :coverPlaceholder="$t('lbl_EMPBE_CompanyInfo_Add_Short_Video')"
                          :gridTemplateColumns="'repeat(2, 1fr)'"
                          :singleAddButton="true"
                          :maxSize="100"
                          :maxDuration="60"
                          fileUsageType="companyVideo_Short"
                          filePathEndpoint="Video"
                          fileThumbnailUsageType="companyVideo_Short_Cover"
                          fileThumbnailPathEndpoint="VideoCapture"
                          :reject-records="getMediaRejectRecords('CompanyShortVideo', companyVideo_Short, 'video')"
                          @update="(cmd, files) => handlerUploaderUpdateData(cmd, files, 'companyVideo_Short')"
                        />
                        <MediaRejectBanner :records="getMediaRejectRecords('CompanyShortVideo', companyVideo_Short, 'video')" />
                      </template>
                    </div>
                  </div>

                  <!--图片集锦-->
                  <div style="border: 1px solid #F0F1F2;;height: 1px;margin-top: 25px;margin-bottom: 25px;"></div>
                  <div class="row">
                    <div class="col-12 mb-2 Input_Label">
                      <div class="Input_Label_Left">
                        3. {{ $t("lbl_EMPBE_CompanyInfo_eBooth_PhotoGallery") }}
                      </div>
                    </div>
                    <div class="col-12 PictureSize"
                      v-html="$t('lbl_EMPBE_CompanyInfo_eBooth_PhotoGallery_P', { nums: GetPhotoGalleryNums })">
                    </div>
                    <div class="col-12">
                      <MediaApprovalGallery
                        v-if="shouldShowMediaApprovalGallery(eBooth_Gallery)"
                        :MediaArray="eBooth_Gallery"
                        mode="admin"
                        media-type="image"
                        :is-show-cover="true"
                        gallery-item-style="height: 77px; width: 138px;"
                        :grid-template-columns="'repeat(2, 1fr)'"
                        :title="$t('lbl_EMPBE_CompanyInfo_eBooth_PhotoGallery')"
                        :approval-content-results="getMediaApprovalResults('PhotoGallery')"
                        :approval-content-result-drafts="getMediaApprovalDraftMap('PhotoGallery', eBooth_Gallery)"
                        :rejection-templates="mediaApprovalRejectionTemplates"
                        :rejection-actor="mediaApprovalRejectionActor"
                        @approval-draft-change="onMediaApprovalDraftChange('PhotoGallery', $event)"
                      />
                      <template v-else>
                        <mediaUploader
                          :isShowCover="true"
                          :isDisabled="isApprovalMediaReadOnly"
                          componentId="eBooth_Gallery"
                          :MediaArray="eBooth_Gallery"
                          ref="eBooth_Gallery"
                          aspectRatioStr="5:3"
                          :limit="GetPhotoGalleryNums"
                          galleryItemStyle="height: 77px; width: 138px;"
                          :coverPlaceholder="$t('lbl_EMPBE_CompanyInfo_Add_Cover_Image')"
                          :gridTemplateColumns="'repeat(2, 1fr)'"
                          :singleAddButton="true"
                          fileUsageType="eBooth_Gallery"
                          filePathEndpoint="Image"
                          :reject-records="getMediaRejectRecords('PhotoGallery', eBooth_Gallery, 'image')"
                          @update="(cmd, files) => handlerUploaderUpdateData(cmd, files, 'eBooth_Gallery')"
                        />
                        <MediaRejectBanner :records="getMediaRejectRecords('PhotoGallery', eBooth_Gallery, 'image')" />
                      </template>
                    </div>
                  </div>
                  <!--end-->
                </div>
              </div>
            </div>
          </div>
        </template>
      </PageValidate>
    </b-overlay>
  </div>
</template>

<script>
import { adService, CompanyInfoService } from "../../_services";
import { fileUploadService } from "@/_services";
import { LogService } from "../../_services/log.Service";
import BasicPageTop from "./Popup/BasicPageTop.vue"
import LogoImgTheme from "./Popup/LogoImgTheme.vue";
import mediaUploader from "../../components/form/upload/imgUploader/mediaUploader.vue";
import MediaRejectBanner from "../../components/form/upload/imgUploader/mediaRejectBanner.vue";
import MediaApprovalGallery from "../../components/form/upload/imgUploader/mediaApprovalGallery.vue";
import mediaApprovalGalleryBridge from "../../components/form/upload/imgUploader/mediaApprovalGalleryBridge.js";
import { getUpdateOSSUrlToDbRequest } from '@/_helpers/utility.js';
import {
  getInitImageDataObj,
  getInitVideoDataObj,
} from '@/_helpers/media-uploader-utils.js';
import CompanyFieldApprovalResults from './CompanyFieldApprovalResults.vue';

export default {
  mixins: [mediaApprovalGalleryBridge],
  components: {
    BasicPageTop, LogoImgTheme,
    mediaUploader, MediaRejectBanner, MediaApprovalGallery, CompanyFieldApprovalResults,
  },
  inject: {
    permissionData: { default: null },
    companyApprovalHost: { default: null },
  },
  props: ["supplierId", "value"],
  data() {
    return {
      //Dirty
      loading: false,
      IsCreated: false,
      dirty: false,
      haveEMPButtonAd: false,
      cdnURL: "https://cdn.adsalecdn.com/EMP/Backend/Images/CompanyInfo/",
      form: {
        empCompanyId: "",
        eBoothTemplate: 0,
        headlineEng: "",
        bodyEng: "",
        headlineCn: "",
        bodyCn: "",
        paraEng1: "",
        paraCn1: "",
        paraEng2: "",
        paraCn2: "",
        mediaFiles: [],
      },
      UploadedList: {
        companyLogo: [],
        homepagePicture: [],
        homepagePicture_MB:[],
        companyImagePictures1: [],
        companyImagePictures2: [],
        companyImagePictures3: [],
        eBooth_Gallery: [],
        companyVideo: [],
        companyVideo_Short: [],
      },
      dbUpdateCommands: {
        companyLogo: [],
        homepagePicture: [],
        homepagePicture_MB:[],
        companyImagePictures1: [],
        companyImagePictures2: [],
        companyImagePictures3: [],
        eBooth_Gallery: [],
        companyVideo: [],
        companyVideo_Short: [],
      },
      pendingUploadFiles: {
        companyLogo: [],
        homepagePicture: [],
        homepagePicture_MB:[],
        companyImagePictures1: [],
        companyImagePictures2: [],
        companyImagePictures3: [],
        eBooth_Gallery: [],
        companyVideo: [],
        companyVideo_Short: [],
      },
      MediaListRef: [
        "companyLogo",
        "homepagePicture",
        "homepagePicture_MB"
      ],
    };
  },
  computed: {
    useFormalTables() {
      const host = this.companyApprovalHost;
      return !!(host && host.fromAdmin && host.isApprovalMode);
    },
    PhotoType() {
      return [
        "companyLogo",
        "homepagePicture",
        "homepagePicture_MB",
        "companyImagePictures1",
        "companyImagePictures2",
        "companyImagePictures3",
        "eBooth_Gallery"
      ];
    },
    VideoType() {
      return ["companyVideo", "companyVideo_Short"];
    },
    VideoThumbnailType() {
      return {
        companyVideo: "companyVideo_Cover",
        companyVideo_Short: "companyVideo_Short_Cover",
      };
    },
    companyLogo(){
      return this.UploadedList.companyLogo;
    },
    homepagePicture(){
      return this.UploadedList.homepagePicture;
    },
    homepagePicture_MB(){
      return this.UploadedList.homepagePicture_MB;
    },
    companyImagePictures1(){
      return this.UploadedList.companyImagePictures1;
    },
    companyImagePictures2(){
      return this.UploadedList.companyImagePictures2;
    },
    companyImagePictures3(){
      return this.UploadedList.companyImagePictures3;
    },
    eBooth_Gallery(){
      return this.UploadedList.eBooth_Gallery;    
    },
    companyVideo(){
      return this.UploadedList.companyVideo;
    },
    companyVideo_Short(){
      return this.UploadedList.companyVideo_Short;
    },
    GetTheme_InfoPrivew() {
      if (this.APlusBooth)
        return `${this.cdnURL}ThemeColorSampleAPlus_${this.langid}.png?`;
      else
        return `${this.cdnURL}ThemeColorSample_${this.langid}.png?`;
    },
    GetEBoothPhotoPrivew() {
      return `${this.cdnURL}HeaderOfEBooth_${this.langid}.png`;
    },
    GetBussinessProfilePrivew() {
      return `${this.cdnURL}Profile_${this.langid}.png`;
    },
    GetHomepagePrivew() {
      return `${this.cdnURL}Homepage_${this.langid}.png`;
    },
    GetBriefIntroductionPrivew() {
      return `${this.cdnURL}BriefIntroduction_${this.langid}.png`;
    },
    user() {
      return this.$store.state.authentication.user;
    },
    GetVideoNums() {
      if (this.permissionData) {
        switch (this.permissionData["Type"]) {
          case "A+":
            return 40;
          case "A":
            return 20;
          case "B":
            return 10;
          case "C":
            return 5;
          case "Member":
            return 3;
          default:
            return 1;
        }
      }
      return 1;
    },
    GetPhotoGalleryNums() {
      if (this.permissionData) {
        switch (this.permissionData["Type"]) {
          case "A+":
            return 40;
          case "A":
            return 20;
          case "B":
            return 10;
          case "C":
            return 5;
          case "Member":
            return 3;
          default:
            return 1;
        }
      }
      return 1;
    },
    APlusBooth() {
      if (this.permissionData) {
        return ["A+"].includes(this.permissionData["Type"]);
      } else {
        return false;
      }
    },
    APlusABCBooth() {
      if (this.permissionData) {
        return ["A+", "A", "B", "C"].includes(this.permissionData["Type"]);
      } else {
        return false;
      }
    },
    MemberAndGuestBooth() {
      if (this.permissionData) {
        return !["A+", "A", "B", "C"].includes(this.permissionData["Type"]);
      } else {
        return true;
      }
    },
    APlusABBooth() {
      if (this.permissionData) {
        return ["A+", "A", "B"].includes(this.permissionData["Type"]);
      } else {
        return false;
      }
    },
    langid() {
      return localStorage.getItem("currentLangId")
    },
  },

  watch: {
    form: {
      handler() {
        if (!this.IsCreated) {
          this.dirty = true;
          this.$store.state.dirty = this.dirty;
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.InitData();
  },
  methods: {
    // [BLK] Only update the stored data arrays for later manipulation
    handlerUploaderUpdateData(commands, pendingFiles, uploaderType) {
      this.dbUpdateCommands[uploaderType] = [...commands];
      this.pendingUploadFiles[uploaderType] = [...pendingFiles];
      // 图片/视频变更不走 form watch，需手动标 dirty，否则切 Tab 不会自动保存
      if (!this.IsCreated) {
        this.dirty = true;
        this.$store.state.dirty = true;
      }
    },

    getInitVideoDataObjWithCoverFile(file, fileProps, coverFile) {
      const coverId = coverFile?.rid;
      const coverCdnLink = coverFile?.fileName;
      const coverOrderId = coverFile?.orderId;
      const coverUsageType = coverFile?.usageType;

      return getInitVideoDataObj(
        file,
        fileProps,
        coverFile ? coverFile : {},
        coverFile ? {
          id: coverId,
          cdnLink: coverCdnLink,
          orderId: coverOrderId,
          usageType: coverUsageType
        } : {}
      );
    },

    resetFilePendingUpdate() {
      for (const key in this.UploadedList) {
        this.$set(this.UploadedList, key, []);
      }

      for (const prop in this.dbUpdateCommands) {
        this.$set(this.dbUpdateCommands, prop, []);
      }

      for (const prop in this.pendingUploadFiles) {
        this.$set(this.pendingUploadFiles, prop, []);
      }
    },

    InitData() {
      this.GetData();
      this.resetFormVerify();
      this.CheckHaveEMPBtnAd();
      setTimeout(() => {
        this.dirty = false;
        this.$store.state.dirty = this.dirty;
      }, 200);
    },
    GetData() {
      this.loading = true;
      this.IsCreated = true;
      this.resetFilePendingUpdate();

      CompanyInfoService.GetCompanyIntro(this.supplierId, this.useFormalTables).then(res => {
        if (res.isSuccessful) {
          this.form = res.data ?? this.form;
          this.form.mediaFiles = res.data.mediaFiles;

          if (res.data.mediaFiles && res.data.mediaFiles.length > 0) {
            this.$nextTick(() => {
              for (const file of res.data.mediaFiles) {
                if (!file.fileName) continue;

                const id = file.rid;
                const cdnLink = file.fileName;
                const orderId = file.orderId;
                const usageType = file.usageType;

                const foundPhotoType = this.PhotoType.find((item) => item.toLowerCase() === usageType.toLowerCase());
                if (foundPhotoType) {
                  this.UploadedList[foundPhotoType].push(getInitImageDataObj(file, { id, cdnLink, orderId, foundPhotoType }));
                }

                const foundVideoType = this.VideoType.find((item) => item.toLowerCase() === usageType.toLowerCase());
                if (foundVideoType) {
                  const thumbnailType = this.VideoThumbnailType[foundVideoType];
                  const coverFile = res.data.mediaFiles.find(
                    (f) => f.usageType.toLowerCase() === thumbnailType.toLowerCase() && f.orderId == file.orderId
                  );
                  this.UploadedList[foundVideoType].push(this.getInitVideoDataObjWithCoverFile(file, { id, cdnLink, orderId, foundVideoType }, {...coverFile, usageType: thumbnailType}));
                }
              }
            });
          }
        }
        setTimeout(() => {
          this.IsCreated = false;
        }, 500);
      }).catch((err) => {
        console.error(err);
      }).finally(() => {
        this.loading = false;
      });
    },
    //判断是否存在广告类型
    CheckHaveEMPBtnAd() {
      const that = this;

      const formIds = "56";
      const adPackageIds = "6,37,38,30";
      
      adService
        .GetAdRecord(this.supplierId, formIds, adPackageIds)
        .then((res) => {
          if (res.isSuccessful) {
            var adRecord = res.data.adRecordInfos;
            
            that.haveEMPButtonAd = adService.AdRecordsHaveAd(adRecord, 37)
              || adService.AdRecordsHaveAd(adRecord, 6) || adService.AdRecordsHaveAd(adRecord, 38) || adService.AdRecordsHaveAd(adRecord, 30) ;
          }
        })
        .finally(() => {
        });
    },
    //重置表单验证
    resetFormVerify() {
      this.$refs.logs.reset();
    },

    fileUploadHandle(isSubmit) {
      const pendingFiles = [];
      const commands = [];

      for (const key in this.pendingUploadFiles) {
        pendingFiles.push(...this.pendingUploadFiles[key]);
      }

      for (const key in this.dbUpdateCommands) {
        commands.push(...this.dbUpdateCommands[key]);
      }

      return this.$submitFormMessage.FileUploadHandleWithPopup({
        isSubmit,
        pendingFiles,
        commands,
        getFailedText: {
          "companyLogo": this.$t("lbl_EMPBE_CompanyInfo_eBooth_CompanyLogo"),
          "homepagePicture": this.$t("lbl_EMPBE_CompanyInfo_eBooth_SpotlightSlidingBanners") + " - " + this.$t("Desktop"),
          "homepagePicture_MB": this.$t("lbl_EMPBE_CompanyInfo_eBooth_SpotlightSlidingBanners") + " - " + this.$t("Mobile"),
          "companyImagePictures1": this.$t("lbl_EMPBE_CompanyInfo_eBooth_TopBanner"),
          "companyImagePictures2": this.$t("lbl_EMPBE_CompanyInfo_eBooth_FirstImageOfCompany"),
          "companyImagePictures3": this.$t("lbl_EMPBE_CompanyInfo_eBooth_SeconedImageOfCompany"),
          "eBooth_Gallery": this.$t("lbl_EMPBE_CompanyInfo_eBooth_PhotoGallery"),
          "companyVideo": this.$t("lbl_EMPBE_CompanyInfo_eBooth_CompanyVideoSubtitle"),
          "companyVideo_Cover": this.$t("lbl_EMPBE_CompanyInfo_eBooth_CompanyVideoSubtitle"),
          "companyVideo_Short": this.$t("lbl_EMPBE_CompanyInfo_eBooth_CompanyShortVideoSubtitle"),
          "companyVideo_Short_Cover": this.$t("lbl_EMPBE_CompanyInfo_eBooth_CompanyShortVideoSubtitle"),
        },
        uploadFinishCallback: (failedFilesFields) => this.$emit("uploadFinish", failedFilesFields)
      });
    },
    //整理結果提交save
    async AfterSaveResult(isSubmit) {
      this.form.mediaFiles = [];
      this.form.validationErrorLog = "";
      var data = this.form;
      data.isSuccessful = true;

      try {
        const uploadRes = await this.fileUploadHandle(isSubmit);

        try {
          await this.SaveFileUrlToDB(getUpdateOSSUrlToDbRequest(uploadRes));
        } catch (err) {
          console.error('UpdateOssUrlToDb failed:', err);
          const msg = err && err.message ? err.message : 'Save OSS URL To DB Failed';
          this.form.validationErrorLog += (this.form.validationErrorLog ? '; ' : '') + msg;
        }
      } catch (error) {
        //console.log("提交的数据Error");
        //console.log(error);
        // 增强错误信息处理
        let errorMessage = '';
        if (error && error.message) {
          errorMessage = error.message;
        } else if (typeof error === 'string') {
          errorMessage = error;
        } else {
          errorMessage = '文件上传失败，请重试';
        }
        
        // 如果是超时或网络错误，提供更友好的提示
        if (errorMessage.includes('timeout') || errorMessage.includes('超时')) {
          errorMessage = '文件上传超时，文件可能过大或网络较慢，请尝试压缩文件后重试';
        } else if (errorMessage.includes('Network Error') || errorMessage.includes('网络')) {
          errorMessage = '网络连接异常，请检查网络连接后重试';
        }
        
        this.form.validationErrorLog += (this.form.validationErrorLog ? '; ' : '') + errorMessage;
        console.error('文件上传错误详情:', error);
      }

      data.validationErrorLog = this.form.validationErrorLog;
      data.empCompanyId = this.supplierId;
      // console.log("提交的数据", data);
      return data;
    },

    LogPageFormError(errorLogObj, action) {
      LogService.LogFormErrorWithObj({
        EmpCompanyId: this.supplierId,
        PageName: this.$route.path.split("/")[1],
        SectionName: "LogoAndImage",
        Action: action,
      }, errorLogObj);
    },

    async SaveFileUrlToDB(uploadData) {
      try {
        const request = {
          ...uploadData,
          EmpCompanyId: this.supplierId,
          EmpProductId: 0
        };

        await fileUploadService.UpdateOssUrlToDb(request);
      } catch (err) {
        this.LogPageFormError({ ErrorName: err.name, ErrorMessage: err.message }, 'UpdateOssUrlToDb');
        throw err;
      }
    },

    async Save() {
      var data = await this.AfterSaveResult();
      //写日志
      const query = {
        FormId: this.supplierId,
        Action: 'Before_Save',
        FormType: 'Company_eBooth',
        ErrorLog: data.validationErrorLog
      };
      LogService.LogFormDataWithObj(query, data);

      return new Promise((resolve, reject) => {
        if (!data.isSuccessful) {
          reject({
            isSuccessful: false,
            popupAlertMsg: this.$t("lbl_EMPBE_Save_Failed_HasError", { msg: data.validationErrorLog }),
          });
        }

        CompanyInfoService.SaveCompanyIntro(data).then(res => {
          if (res.isSuccessful) {
            this.InitData();
            resolve({
              isSuccessful: true,
              popupAlertMsg: this.$t("lbl_EMPBE_SubmitAlert_SaveSuccessMessage"),
            });
          } else {
            this.LogPageFormError({ res: res }, "Save_SaveCompanyIntro");
            reject({
              isSuccessful: false,
              popupAlertMsg: this.$t("lbl_EMPBE_Save_Failed_HasErrorAndCode", { code: res.statusCode, msg: res.msg?.join(",") || "Error" }),
            });
          }
        }).catch(err => {
          this.LogPageFormError({ ErrorName: err.name, ErrorMessage: err.message }, "Save_SaveCompanyIntro");
          reject({
            isSuccessful: false,
            popupAlertMsg: this.$t("lbl_EMPBE_Save_Failed_HasError", { msg: err.message }),
            error: err,
          });
        })
      });
    },
    //提交
    async Submit() {
      var data = await this.AfterSaveResult();

      const query = {
        FormId: this.supplierId,
        Action: 'Before_Submit',
        FormType: 'Company_eBooth',
        ErrorLog: data.validationErrorLog
      };
      LogService.LogFormDataWithObj(query, data);

      return new Promise((resolve, reject) => {
        if (!data.isSuccessful) {
          reject({
            isSuccessful: false,
            popupAlertMsg: this.$t("lbl_EMPBE_Save_Failed_HasError", { msg: data.validationErrorLog }),
          });
        }

        CompanyInfoService.SaveCompanyIntro(data).then(result => {
          console.log("SaveCompanyIntro", result);
          if (result.isSuccessful) {
            this.$refs.logs
              .validate(true)
              .then(async (res) => {
                if (process.env.VUE_APP_EMP_ENV_NAME?.toLowerCase() == 'ai' || res.valid) {
                  //写日志
                  data.VaildError = res.fIldData;
                  
                  this.InitData();
                  resolve({
                    isSuccessful: true,
                    isAllMandatoryFieldFilled: true,
                  });
                } else {
                  this.GetData();
                  resolve({
                    isSuccessful: true,
                    isAllMandatoryFieldFilled: false,
                  });
                }
              });
          } else {
            this.LogPageFormError({ result: result }, "Submit_SaveCompanyIntro");
            reject({
              isSuccessful: false,
              popupAlertMsg: this.$t("lbl_EMPBE_Submit_Failed_HasErrorAndCode", { code: result.statusCode, msg: result.msg?.join(",") || "Error" }),
            });
          }
        }).catch(err => {
          this.LogPageFormError({ ErrorName: err.name, ErrorMessage: err.message }, "Submit_SaveCompanyIntro");
          reject({
            isSuccessful: false,
            popupAlertMsg: this.$t("lbl_EMPBE_Submit_Failed_HasError", { msg: err.message }),
            error: err,
          });
        });
      });

    }
  },
};
</script>
<style scoped>
/* Company Logo only — keep mediaUploader global styles untouched */
.company-logo-uploader ::v-deep .gallery-item,
.company-logo-uploader ::v-deep .gallery-item-round {
  border-radius: 50%;
  overflow: visible;
}
.company-logo-uploader ::v-deep .gallery-img,
.company-logo-uploader ::v-deep .gallery-img-round {
  border-radius: 50%;
}
.company-logo-uploader ::v-deep .gallery-item-corner.bottom-right {
  bottom: -6px;
  right: -6px;
}
.company-logo-uploader ::v-deep .gallery-item-corner.top-right {
  top: -6px;
  right: -6px;
}
/* Admin approval gallery preview */
.company-logo-uploader ::v-deep .mag-thumb,
.company-logo-uploader ::v-deep .mag-thumb-img {
  border-radius: 50%;
}
</style>